module.exports = __webpack_public_path__ + "img/leverage-icon.404ceeb6.png";